'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPinpoint = function IoPinpoint(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c2.5-2.5 4-5.8 4.3-9.3l-4.9-0.7v-1.2l4.9-0.6c-0.3-3.6-1.8-6.9-4.3-9.4s-5.8-4-9.4-4.3l-0.6 4.9h-1.2l-0.6-4.9c-3.6 0.3-6.9 1.8-9.4 4.3s-4 5.8-4.3 9.4l4.9 0.6v1.2l-4.9 0.7c0.3 3.5 1.8 6.8 4.3 9.3s5.8 4 9.4 4.3l0.6-4.9h1.2l0.7 4.9c3.5-0.3 6.8-1.8 9.3-4.3z' })
        )
    );
};

exports.default = IoPinpoint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pinpoint.js
// module id = 2861
// module chunks = 168707334958949